type AuthLike = {
  authenticated?: boolean;
  companyName?: string | null;
  isDashboardEnabled?: boolean;
  roles?: Array<{ authority?: string | null }> | null;
};

type CompanyLike = {
  name?: string | null;
};

type FeatureFlagsLike = {
  featureFlagsArray?: string[];
};

export function hasAuthority(auth: AuthLike | null | undefined, authority: string): boolean {
  return Boolean(
    auth?.roles?.some((role: { authority?: string | null }) => role.authority === authority)
  );
}

export function isFeatureFlagOn(
  featureFlags: FeatureFlagsLike | null | undefined,
  flagName: string
): boolean {
  return Boolean(featureFlags?.featureFlagsArray?.includes(flagName));
}

export function getHeaderTitle(auth: AuthLike, company: CompanyLike): string {
  let companyName: string | null | undefined = '';
  if (auth.authenticated) {
    companyName = auth.companyName;
  }

  if (companyName === null || companyName === undefined) {
    return 'ThingsLog';
  }

  if (company.name === null) {
    return companyName;
  }

  return `${companyName} - ${company.name}`;
}

export function isSettingsMenuItemVisible(
  auth: AuthLike,
  featureFlags: FeatureFlagsLike | null | undefined
): boolean {
  return (
    isFeatureFlagOn(featureFlags, 'SETTINGS_PAGE') &&
    (hasAuthority(auth, 'ROLE_ADMIN') || hasAuthority(auth, 'ROLE_SUPER_ADMIN'))
  );
}

export function hasSelectedCompany(selectedCompanyRaw: string | null): boolean {
  if (!selectedCompanyRaw) {
    return false;
  }

  try {
    const selectedCompany = JSON.parse(selectedCompanyRaw);
    return selectedCompany.id !== undefined && selectedCompany.id !== null;
  } catch {
    return false;
  }
}

export function isAgriIconVisible(auth: AuthLike, selectedCompanyRaw: string | null): boolean {
  const isDashboardEnabled = auth.isDashboardEnabled ? auth.isDashboardEnabled : false;
  const hasAdminRole = hasAuthority(auth, 'ROLE_ADMIN');
  const hasSuperAdminRole = hasAuthority(auth, 'ROLE_SUPER_ADMIN');

  return (
    isDashboardEnabled ||
    ((hasAdminRole || hasSuperAdminRole) && hasSelectedCompany(selectedCompanyRaw))
  );
}
